import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { savedOrderDetailsCartLineStyles } from "@dana/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.container = mergeToNew(savedOrderDetailsCartLineStyles.container, {
    css: css`
        background: ${themeBackgrounds.white};
        padding: 1rem;
        @media print {
            padding: 4px 0;
            margin: 1px;
            .productDescriptionAndPartNumbersContainer > [class*="GridOffset"],
            > [class*="GridOffset"] {
                width: 100%;
                margin: 0;
                display: flex;
                > div {
                    padding: 0; 
                }
            }
                
            [data-test-selector="productNumberLink"] {
                > span {
                    margin: 0; 
                }
            }
            .productDescriptionAndPartNumbersContainer {
                div[class*="GridOffset"] {
                    width: 100%;
                    margin: 0;
                    > div {
                        padding: 0;
                    }
                }
                * {
                    font-size: 0.625rem !important;
                }
            }
        }
    `,
});

savedOrderDetailsCartLineStyles.productImageGridItem = mergeToNew(
    savedOrderDetailsCartLineStyles.productImageGridItem,
    {
        width: [3, 3, 3, 1, 1],
        css: css`
            @media print {
                justify-content: center;
                display: flex;
                padding-right: 16px;
                max-width: 76px;
                flex-basis: 76px;
                > a {
                    max-width: 60px;
                    img {
                        max-height: 60px;
                    } 
                }
            }
        `
    },
);

savedOrderDetailsCartLineStyles.savedOrderLineInfoGridItem = mergeToNew(
    savedOrderDetailsCartLineStyles.savedOrderLineInfoGridItem,
    {
        width: [9, 9, 9, 11, 11],
        css: css`
            @media print {
                max-width: calc(100% - 76px);
                flex-basis: calc(100% - 76px);
            }
        `
    },
);

savedOrderDetailsCartLineStyles.productPrice = mergeToNew(savedOrderDetailsCartLineStyles.productPrice, {
    priceLabelText: {
        forwardAs: "span",
        size: fontSizes.small,
        lineHeight: lineHeights.default,
        color: themeBackgrounds.darkGray,
        transform: "capitalize",
        css: css`
            margin-bottom: 10px;
        `,
    },
    price: {
        priceText: {
            size: fontSizes.small,
            lineHeight: lineHeights.default,
            fontWeight: fontWeights.semiBold,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: fontSizes.xSmall,
                lineHeight: lineHeights.default,
                fontWeight: fontWeights.semiBold,
            },
        },
    },
});

savedOrderDetailsCartLineStyles.quantityGridItem = mergeToNew(savedOrderDetailsCartLineStyles.quantityGridItem, {
    width: [6, 6, 6, 6, 6],
    css: css`
        [data-test-selector="heading"] {
            font-weight: ${fontWeights.semiBold};
            color: ${themeBackgrounds.darkGray};
            line-height: ${lineHeights.default};
            font-size: ${fontSizes.small};
            text-transform: capitalize;
            font-weight: ${fontWeights.semiBold};
            margin-bottom: 10px;
        }
        [data-test-selector*="text_"] {
            size: ${fontSizes.small};
            line-height: ${lineHeights.default};
        }
    `,
});

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListGridItem = mergeToNew(
    savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListGridItem,
    {
        width: [12, 12, 6, 6, 6],
    },
);

savedOrderDetailsCartLineStyles.extendedUnitNetPriceGridItem = mergeToNew(
    savedOrderDetailsCartLineStyles.extendedUnitNetPriceGridItem,
    {
        width: [6, 6, 4, 3, 3],
        css: css`
            [data-test-selector="heading"] {
                font-weight: ${fontWeights.semiBold};
                color: ${themeBackgrounds.darkGray};
                line-height: ${lineHeights.default};
                font-size: ${fontSizes.small};
                text-transform: capitalize;
                font-weight: ${fontWeights.semiBold};
                margin-bottom: 10px;
            }
            [data-test-selector*="text_"] {
                size: ${fontSizes.small};
                line-height: ${lineHeights.default};
                font-weight: ${fontWeights.semiBold};
            }
        `,
    },
);

savedOrderDetailsCartLineStyles.productPartNumbers = mergeToNew(savedOrderDetailsCartLineStyles.productPartNumbers, {
    erpNumberLabelText: {
        weight: fontWeights.semiBold,
    },
    customerNameLabelText: {
        weight: fontWeights.semiBold,
    },
    manufacturerItemLabelText: {
        weight: fontWeights.semiBold,
    },
});

savedOrderDetailsCartLineStyles.productDescriptionAndPartNumbersGridItem = mergeToNew(savedOrderDetailsCartLineStyles.productDescriptionAndPartNumbersGridItem, {
    width: [12, 12, 7, 7, 7],
    printWidth: 9,
});

savedOrderDetailsCartLineStyles.productPriceAndQuantityGridItem = mergeToNew(savedOrderDetailsCartLineStyles.productPriceAndQuantityGridItem, {
    width: [12, 12, 5, 5, 5],
    printWidth: 3,
});

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListButton = mergeToNew(savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListButton, {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                null,
                null,
                css`
                    width: 100%;
                `,
            ],
            "min",
        )}
    `
});

savedOrderDetailsCartLineStyles.productAvailabilityGridItem = mergeToNew(savedOrderDetailsCartLineStyles.productAvailabilityGridItem, {
    css: css`
        padding-top: 0;
        padding-bottom: 0
    `
});

savedOrderDetailsCartLineStyles.savedOrderLineInfoContainer = mergeToNew(savedOrderDetailsCartLineStyles.savedOrderLineInfoContainer, {
    css: css`
        @media print {
            > div[class*="GridOffset"] {
                width: 100%;
                margin: 0;
                > div {
                    padding: 0; 
                } 
            }
        }
    `
})